import React, { Component } from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import ContainerBox from "./components/ContainerBox";
import Navigation from "./components/Navigation";
import PinInput from "./components/PinInput";
import { reduxForm, SubmissionError } from 'redux-form';
import { requestValidationMessage } from '../../modules/user/actions'
import { requestVerification } from '../../modules/user/actions'

function mapStateToProps(state) {
  return {
    email: state.user.email
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    requestValidationMessage,
    requestVerification,
  }, dispatch);
}


class ConfirmEmail extends Component {

  componentWillMount() {
    this.setState(state=>({...state, loading: false}));
  }

  submit(results) {
    console.log(JSON.stringify(results, null, 2));
    return new Promise((resolve, reject) => {
      if (!results.pin || results.pin.length < 6) {
        return reject(new SubmissionError({
          'pin': 'Please fill in all numbers.'
        }));
      }

      this.props.requestVerification({
        email: this.props.email, 
        token: results.pin,
        type: 'email',
        callback: (result) => {
          if (!result.err) {
            this.props.history.push('/signup-enter-mobile');
            return resolve();
          } else {
            if (result.err.message === 'PIN Limit Exceeded') {
              this.props.history.push(`/too-many-pin-attempts`);
            }
            return reject(new SubmissionError({
              pin: result.err.message
            }));
          }
        }
      });
    });
  }

  resendCode() {
    this.setState(state=>({...state, loading: true}));
    let isWaiting = true;
    setTimeout(() => {
      if (!isWaiting) {
        this.setState(state=>({...state, loading: false}));
      } else {
        isWaiting = false;
      }
    }, 1000);
    this.props.requestValidationMessage({
      email: this.props.email,
      callback: ()=>{
        if (!isWaiting) {
          this.setState(state=>({...state, loading: false}));
        } else {
          isWaiting = false;
        }
      }
    });
  }

  render() {
    return (
      <ContainerBox type="signup-confirm-email" title="Confirm email" isLoading={this.props.submitting || this.state.loading}>
        <p><strong className="blue">{this.props.email}</strong></p>
        <p>A message with a verification code was sent to your email address. Please enter the code below.</p>
        <form onSubmit={this.props.handleSubmit(results => this.submit(results))} autoComplete="off">
          <PinInput name="pin" length={6} resendCode={()=>this.resendCode()} onSubmit={this.props.handleSubmit(results => this.submit(results))}/>
          <Navigation secondaryText="Back" secondaryLink="/signup" primaryText="Next" primaryLink="/signup-enter-mobile" />
        </form>

      </ContainerBox>
    )
  }
}

ConfirmEmail = reduxForm({
  form: 'ConfirmEmail' // a unique name for this form
})(ConfirmEmail);

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmEmail);